import logo from "./logo.svg";
import "./App.scss";
import Intercom from "react-intercom";

import SafetyAppSEO from "./Components/SEO/SafetyAppSEO";
import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";

import { GetADemoPage } from "./Components/GetADemo/GetADemoPage";
import { SafetyAppPage } from "./Pages/SafetyAppPage";
import PrivacyStatement from "./Components/Privacy/PrivacyStatement";

function App() {
  function IntercomAutoOpen() {
    useEffect(() => {
      const handleScroll = () => {
        if (window.innerWidth < 768) return;

        if (window.scrollY > 200) {
          if (window.Intercom) {
            window.Intercom("show");
          }
          window.removeEventListener("scroll", handleScroll);
        }
      };

      window.addEventListener("scroll", handleScroll);

      return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    return null;
  }

  return (
    <div className="App">
      <SafetyAppSEO />
      <Routes>
        <Route path="/get-a-demo" element={<GetADemoPage />} />

        <Route path="/" element={<SafetyAppPage />} />

        <Route path="/privacy-statement" element={<PrivacyStatement />} />
      </Routes>
    </div>
  );
}

export default App;
